var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicroscope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 167,
    viewBox: "0 0 153 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.8309 84.1478L69.9987 113.977C69.9987 113.977 80.6075 110.664 95.8541 115.966C98.4191 116.857 102.711 112.565 101.819 110C96.5178 94.7537 99.8309 84.1478 99.8309 84.1478V84.1478Z",
    fill: "url(#paint0_linear_793_77)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9925 34.1388C38.105 16.0291 67.5097 16.0291 85.6222 34.1388C103.732 52.2513 103.732 81.6559 85.6222 99.7684C67.5097 117.878 38.105 117.878 19.9925 99.7684C1.88281 81.6559 1.88281 52.2513 19.9925 34.1388V34.1388Z",
    fill: "url(#paint1_linear_793_77)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.6231 29.0706C81.7608 30.5896 83.7675 32.2849 85.6222 34.1388C103.732 52.2513 103.732 81.6559 85.6222 99.7684C67.5097 117.878 38.105 117.878 19.9925 99.7684C18.9266 98.6997 17.9225 97.5944 16.9803 96.4553C34.5359 102.159 54.6003 98.0416 68.5391 84.1028C83.4059 69.2359 87.1016 47.3997 79.6231 29.0706V29.0706Z",
    fill: "#E5EEF8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0156 30.1619C36.3219 9.85563 69.2928 9.85563 89.5991 30.1619C109.905 50.4681 109.905 83.4391 89.5991 103.745C69.2928 124.052 36.3219 124.052 16.0156 103.745C-4.29063 83.4391 -4.29063 50.4681 16.0156 30.1619V30.1619ZM21.9809 36.1272C38.9937 19.1144 66.6209 19.1144 83.6337 36.1272C100.647 53.14 100.647 80.7672 83.6337 97.78C66.6209 114.793 38.9937 114.793 21.9809 97.78C4.96812 80.7672 4.96812 53.14 21.9809 36.1272V36.1272Z",
    fill: "url(#paint2_linear_793_77)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.19156 90.0906C-3.46094 70.631 -0.187188 46.3647 16.0156 30.1619C31.2312 14.9463 53.5569 11.1325 72.3416 18.7206C72.5836 21.8125 72.6109 24.9175 72.4231 28.0131C56.0797 19.7838 35.6216 22.4894 21.9809 36.1272C7.52188 50.5863 5.35063 72.7122 15.4728 89.4747C12.5084 89.8797 9.48219 90.0906 6.41094 90.0906H6.19156V90.0906Z",
    fill: "url(#paint3_linear_793_77)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5759 125.621C91.2024 123.247 89.869 120.028 89.869 116.672C89.869 113.315 91.2024 110.096 93.5759 107.722C95.9495 105.349 99.1686 104.015 102.525 104.015C105.882 104.015 109.101 105.349 111.475 107.722L152.245 148.492C153.342 149.589 150.222 154.491 145.284 159.43C140.345 164.369 135.443 167.488 134.346 166.391L93.5759 125.621Z",
    fill: "url(#paint4_linear_793_77)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5759 125.621C91.2024 123.247 89.869 120.028 89.869 116.672C89.869 113.315 91.2024 110.096 93.5759 107.722C95.9495 105.349 99.1686 104.015 102.525 104.015C105.882 104.015 109.101 105.349 111.475 107.722L148.375 144.622C149.472 145.719 146.352 150.621 141.414 155.56C136.475 160.499 131.573 163.618 130.476 162.521L93.5759 125.621V125.621Z",
    fill: "url(#paint5_linear_793_77)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8491 58.0984C46.7844 55.4181 47.7912 53.4606 49.3437 52.3131C51.785 50.5131 55.4328 50.5891 57.4128 52.8194C58.2622 53.7784 58.7544 55.1341 58.7684 56.8497C58.8022 60.9644 56.8728 63.3691 54.9828 65.8581C52.4403 69.2134 49.9006 72.6616 49.5856 78.4188C49.545 79.1639 49.802 79.8947 50.3002 80.4504C50.7983 81.0061 51.4968 81.3411 52.242 81.3817C52.9872 81.4224 53.718 81.1653 54.2737 80.6672C54.8293 80.169 55.1643 79.4705 55.205 78.7253C55.4412 74.3519 57.5337 71.8038 59.4659 69.2556C62.0534 65.8441 64.4412 62.4409 64.3934 56.8047C64.3653 53.4916 63.26 50.935 61.6175 49.0844C57.7812 44.7644 50.7359 44.2975 46.0053 47.785C43.1703 49.8775 41.1087 53.3425 41.2241 58.2306C41.2416 58.9766 41.5547 59.685 42.0946 60.2C42.6344 60.7151 43.3567 60.9946 44.1027 60.977C44.8486 60.9595 45.557 60.6464 46.072 60.1065C46.5871 59.5667 46.8666 58.8444 46.8491 58.0984Z",
    fill: "url(#paint6_linear_793_77)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1338 91.8259C54.0443 91.8259 55.5931 90.2771 55.5931 88.3665C55.5931 86.456 54.0443 84.9072 52.1338 84.9072C50.2232 84.9072 48.6744 86.456 48.6744 88.3665C48.6744 90.2771 50.2232 91.8259 52.1338 91.8259Z",
    fill: "url(#paint7_linear_793_77)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.747 18.8978L111.185 4.83531C111.375 4.5186 111.501 4.16756 111.555 3.80224C111.61 3.43692 111.591 3.06446 111.502 2.70615C111.412 2.34783 111.253 2.01066 111.033 1.7139C110.813 1.41714 110.537 1.16659 110.22 0.976564C109.904 0.786537 109.553 0.660752 109.187 0.606391C108.822 0.552029 108.449 0.570156 108.091 0.659735C107.733 0.749315 107.396 0.908593 107.099 1.12848C106.802 1.34836 106.552 1.62454 106.362 1.94125L97.9241 16.0038C97.5403 16.6434 97.4263 17.4093 97.6072 18.1329C97.7882 18.8566 98.2491 19.4787 98.8888 19.8625C99.5284 20.2463 100.294 20.3602 101.018 20.1793C101.742 19.9984 102.364 19.5374 102.747 18.8978Z",
    fill: "url(#paint8_linear_793_77)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.053 28.165L146.991 5.665C147.594 5.2264 147.999 4.56604 148.115 3.8292C148.232 3.09236 148.051 2.33939 147.613 1.73594C147.395 1.43714 147.121 1.18404 146.806 0.991097C146.491 0.798152 146.142 0.669137 145.777 0.61142C145.04 0.494854 144.287 0.675773 143.683 1.11437L112.746 23.6144C112.142 24.053 111.738 24.7133 111.621 25.4502C111.505 26.187 111.686 26.94 112.124 27.5434C112.563 28.1469 113.223 28.5514 113.96 28.668C114.697 28.7845 115.45 28.6036 116.053 28.165Z",
    fill: "url(#paint9_linear_793_77)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.705 45.4928L143.205 39.8678C143.569 39.7835 143.912 39.6275 144.215 39.4091C144.518 39.1907 144.774 38.9142 144.969 38.5956C145.164 38.2771 145.294 37.923 145.35 37.5539C145.407 37.1848 145.389 36.8081 145.299 36.4459C145.208 36.0836 145.046 35.743 144.823 35.444C144.599 35.1449 144.318 34.8933 143.996 34.704C143.675 34.5146 143.318 34.3912 142.948 34.341C142.578 34.2908 142.202 34.3148 141.841 34.4116L119.341 40.0366C118.629 40.2277 118.02 40.691 117.646 41.3267C117.272 41.9624 117.163 42.7196 117.342 43.4351C117.52 44.1507 117.973 44.7673 118.602 45.1522C119.232 45.5371 119.987 45.6594 120.705 45.4928V45.4928Z",
    fill: "url(#paint10_linear_793_77)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_793_77",
    x1: 97.5352,
    y1: 88.3744,
    x2: 89.4468,
    y2: 116.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14A800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_793_77",
    x1: 20.2756,
    y1: 40.8974,
    x2: 85.2682,
    y2: 100.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_793_77",
    x1: 67.476,
    y1: 22.965,
    x2: 86.247,
    y2: 106.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA3BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_793_77",
    x1: 24.197,
    y1: 20.5729,
    x2: 47.845,
    y2: 92.6088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_793_77",
    x1: 131.423,
    y1: 127.672,
    x2: 117.808,
    y2: 153.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA3BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_793_77",
    x1: 127.863,
    y1: 124.11,
    x2: 116.748,
    y2: 148.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_793_77",
    x1: 41.21,
    y1: 45.5448,
    x2: 55.5816,
    y2: 91.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14A800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_793_77",
    x1: 41.21,
    y1: 45.5447,
    x2: 55.5816,
    y2: 91.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14A800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_793_77",
    x1: 134.018,
    y1: 10.2753,
    x2: 99.6127,
    y2: 35.8651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14A800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_793_77",
    x1: 134.018,
    y1: 10.2753,
    x2: 99.6127,
    y2: 35.8651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14A800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_793_77",
    x1: 134.018,
    y1: 10.2753,
    x2: 99.6127,
    y2: 35.8651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14A800"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroscope);
export default __webpack_public_path__ + "static/media/microscope.e9b2e4ac4ad100fca729a7e47674ba05.svg";
export { ForwardRef as ReactComponent };